
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui/types/element-ui'
import moment from 'moment'

import { BankTransfer } from '@/models'
import { useUserStore } from '@/stores/user'
import { extractApiErrorMessages } from '@/utils/apiErrors'

interface AcompteForm {
  amount: string
  comment: string
}

@Component({ name: 'NewAcompte' })
export default class extends Vue {
  form: AcompteForm = { amount: '', comment: '' }
  submitting = false
  commentMaxLength = 1000
  orderId: string | null = null
  orderReference: string | null = null

  rules: any = {
    amount: [
      { required: true, message: this.$t('newAcompte.form.rules.amount'), trigger: 'blur' }
    ]
  }

  created(): void {
    const amount = Number(this.$route.query.amount)
    if (this.$route.query.amount && !Number.isNaN(amount) && amount > 0) {
      this.form.amount = String(amount)
    }

    if (this.$route.query.orderId) {
      this.orderId = String(this.$route.query.orderId)
      this.orderReference = this.$route.query.orderReference ? String(this.$route.query.orderReference) : null
    }
  }

  submit(): void {
    (this.$refs.acompteFormRef as ElForm).validate(async(valid) => {
      if (!valid) return

      this.submitting = true
      try {
        const userStore = useUserStore()
        const bankTransfer = new BankTransfer({
          manageable: userStore.model?.manageable,
          amount: Number(this.form.amount),
          comment: this.form.comment,
          pending: true,
          orderDate: moment().format('YYYY-MM-DD'),
          reserved: !!this.orderId,
          multiChoiceCardOrderId: this.orderId || undefined
        })

        await bankTransfer.save({ with: 'manageable.id' })

        const subtitleKey = this.orderId
          ? 'newAcompte.notifications.success.subtitleReserved'
          : 'newAcompte.notifications.success.subtitle'
        this.$notify({
          title: this.$t('newAcompte.notifications.success.title') as string,
          message: this.$t(subtitleKey, { reference: bankTransfer.orderReference }) as string,
          type: 'success',
          duration: 6000
        })
        this.$router.push('/gifts/orders')
      } catch (err: any) {
        const messages = extractApiErrorMessages(err)
        this.$notify({
          title: this.$t('newAcompte.notifications.error.title') as string,
          message: messages.join('\n') || String(this.$t('newAcompte.notifications.error.subtitle')),
          type: 'error',
          duration: 6000
        })
      } finally {
        this.submitting = false
      }
    })
  }
}
